import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AdminGuard {
  constructor(public authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const isAdmin = localStorage.getItem('isAdmin');
    const isSuperAdmin = localStorage.getItem('isSuperAdmin');
    if (isAdmin || isSuperAdmin) {
      return true;
    }
    this.router.navigate(['/pages/home']);
    return false;
  }
};
